import { render, staticRenderFns } from "./CommentsModal.vue?vue&type=template&id=0d2aca18&scoped=true"
import script from "./CommentsModal.vue?vue&type=script&lang=js"
export * from "./CommentsModal.vue?vue&type=script&lang=js"
import style0 from "./CommentsModal.css?vue&type=style&index=0&id=0d2aca18&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2aca18",
  null
  
)

export default component.exports